interface MapSalesRepresentativeDataParams {
  id: string;
  name: string;
  code: string;
  isMine: boolean;
}

export const mapSalesRepresentativeToOfflineData = ({
  id,
  name,
  code,
  isMine,
}: MapSalesRepresentativeDataParams) => {
  return {
    id,
    name,
    code,
    isMine,
  };
};
